import CRMauth from "@/services/CRMinitAuth"

const quickReserve = payload =>
  CRMauth.post(`${process.env.VUE_APP_CRM_API}candidates/actions/quick_add_exam_request/`, payload);

export default {
  quickReserve
}